/* tslint:disable */
/* eslint-disable */
/**
 * V2M Backend API
 * Backend API for the V2M multi-brand platform (word2mail, koe2mail, sprich2mail, ...) - handles authentication, quota management, and LLM requests
 *
 * The version of the OpenAPI document: 1.0.5
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * Check if a given object implements the DispatchCampaignResponse interface.
 */
export function instanceOfDispatchCampaignResponse(value) {
    if (!('tasksEnqueued' in value) || value['tasksEnqueued'] === undefined)
        return false;
    return true;
}
export function DispatchCampaignResponseFromJSON(json) {
    return DispatchCampaignResponseFromJSONTyped(json, false);
}
export function DispatchCampaignResponseFromJSONTyped(json, _ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'tasksEnqueued': json['tasks_enqueued'],
    };
}
export function DispatchCampaignResponseToJSON(json) {
    return DispatchCampaignResponseToJSONTyped(json, false);
}
export function DispatchCampaignResponseToJSONTyped(value, _ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'tasks_enqueued': value['tasksEnqueued'],
    };
}
